import React from "react"

class LoadingSpinner extends React.Component {
	componentDidMount() {
		document.getElementById('content').classList.add('loading')
		//document.body.classList.add('loading')
	}
	componentWillUnmount() {
		document.getElementById('content').classList.remove('loading')
		//document.body.classList.remove('loading')
	}
	render() {
		return <React.Fragment />
	}
}
export default LoadingSpinner